import * as Yup from 'yup'

const timeIntervalSchema = Yup.object().shape({
  start: Yup.string()
    .matches(/^([01]\d|2[0-3]):([0-5]\d)$/, 'Formato de horário de início inválido')
    .required('O horário de início é obrigatório'),
  end: Yup.string()
    .matches(/^([01]\d|2[0-3]):([0-5]\d)$/, 'Formato de horário de término inválido')
    .required('O horário de término é obrigatório'),
})

export const roomSchema = Yup.object().shape({
  franchise: Yup.number().nullable().required('Selecione a franquia'),
  name: Yup.string().min(3).max(64).required('Insira o nome'),
  syncName: Yup.string().min(3).max(64).required('Insira o nome de sincronização'),
  categories: Yup.array().min(1, 'Selecione uma categoria'),
  products: Yup.array().min(1, 'Selecione um produto'),
  maxScheduleDate: Yup.number().required('Insira o range'),
  intervals: Yup.array()
    .of(Yup.array().of(timeIntervalSchema).nullable())
    .required('Preenchimento obrigatório de horário'),
})
